import Text from 'components/Text/Text';
import { useLoggedUserRestaurants } from 'hooks/useLoggedUserRestaurants';
import style from './RestaurantsScrollableList.module.scss';
import React from 'react';

interface IRestaurantsScrollableListRestaurant {
	id: string;
	restaurantName: string | null;
}

interface IProps {
	restaurants: IRestaurantsScrollableListRestaurant[];
	isNewTooltip?: boolean;
}

const RestaurantsScrollableList: React.FC<IProps> = ({ restaurants, isNewTooltip = false }) => {
	const accessibleRestaurants = useLoggedUserRestaurants(restaurants);

	return (
		<div className={style.container} data-test="RestaurantsScrollView">
			{accessibleRestaurants.length
				? accessibleRestaurants.map((el) => (
						<div key={el.id} className={style.item}>
							<div className={style.dot} />
							<Text translationKey={el.restaurantName} withTooltip={true} isNewTooltip={isNewTooltip} />
						</div>
				  ))
				: '-'}
		</div>
	);
};

export default React.memo(RestaurantsScrollableList);
